/**
 * Limite connue de l'export d'un compte, a dire **avant** tout geste d'export.
 *
 * L'export d'un compte (`POST /admin/users/{id}/exports`, `DataPortability`) ne
 * lit que les tables REST. Les saisies faites sur les telephones vivent dans le
 * journal de synchronisation, que l'export ne lit pas encore (#527). Tant que ce
 * n'est pas livre, **aucun ecran ne presente un export comme une reponse complete**
 * a une demande d'acces : les deux phrases ci-dessous se lisent ensemble, et se
 * retirent ensemble le jour ou #527 est livree.
 */

/**
 * « #527 » s'ecrit en deux morceaux : le garde-fou des couleurs
 * (`ui/noHexLiteral.test.ts`) lit `#527` comme un code hexadecimal a trois chiffres.
 */
const ISSUE_REFERENCE = '#'.concat('527');

export const EXPORT_LIMITATION = `L’export ne contient pas encore les saisies synchronisées depuis les téléphones — voir ${ISSUE_REFERENCE}.`;

export const EXPORT_NOT_A_COMPLETE_ANSWER = 'Il ne constitue donc pas, à lui seul, une réponse complète à une demande d’accès.';
